/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiCustomListsDtoCustomListItemFieldValueDto } from './WebApiCustomListsDtoCustomListItemFieldValueDto';
import {
    WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSON,
    WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSONTyped,
    WebApiCustomListsDtoCustomListItemFieldValueDtoToJSON,
} from './WebApiCustomListsDtoCustomListItemFieldValueDto';

/**
 * 
 * @export
 * @interface WebApiCustomListsDtoCreateCustomListItemDto
 */
export interface WebApiCustomListsDtoCreateCustomListItemDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCreateCustomListItemDto
     */
    customListId?: number | null;
    /**
     * 
     * @type {Array<WebApiCustomListsDtoCustomListItemFieldValueDto>}
     * @memberof WebApiCustomListsDtoCreateCustomListItemDto
     */
    fieldValues?: Array<WebApiCustomListsDtoCustomListItemFieldValueDto> | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCreateCustomListItemDto
     */
    memberId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCreateCustomListItemDto
     */
    createdBy?: number | null;
}

/**
 * Check if a given object implements the WebApiCustomListsDtoCreateCustomListItemDto interface.
 */
export function instanceOfWebApiCustomListsDtoCreateCustomListItemDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListsDtoCreateCustomListItemDtoFromJSON(json: any): WebApiCustomListsDtoCreateCustomListItemDto {
    return WebApiCustomListsDtoCreateCustomListItemDtoFromJSONTyped(json, false);
}

export function WebApiCustomListsDtoCreateCustomListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListsDtoCreateCustomListItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customListId': !exists(json, 'customListId') ? undefined : json['customListId'],
        'fieldValues': !exists(json, 'fieldValues') ? undefined : (json['fieldValues'] === null ? null : (json['fieldValues'] as Array<any>).map(WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSON)),
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
    };
}

export function WebApiCustomListsDtoCreateCustomListItemDtoToJSON(value?: WebApiCustomListsDtoCreateCustomListItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'customListId': value.customListId,
        'fieldValues': value.fieldValues === undefined ? undefined : (value.fieldValues === null ? null : (value.fieldValues as Array<any>).map(WebApiCustomListsDtoCustomListItemFieldValueDtoToJSON)),
        'memberId': value.memberId,
        'createdBy': value.createdBy,
    };
}

